export const appRootId = "m-app"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5, viewport-fit=cover"},{"charset":"utf-8"},{"name":"applicable-device","content":"pc,mobile"},{"name":"description","content":"喵御宅(mfuns.net)是一个纯粹的二次元社区，这里充满了动漫、漫画、游戏、鬼畜、轻小说宅舞、音乐、cosplay等ACG元素。在喵御宅，您可以畅享弹幕视频、文章、图片和插画等作品，也可以成为创作者，分享你关于ACGN的创意和欢乐! 加入我们，一同探索这个充满创意和想象力的ACG世界！"},{"name":"keywords","content":"喵御宅,二次元,社区,动漫,游戏,轻小说,cos,cosplay,弹幕视频,弹幕,字幕,AMV,MAD,MTV,ANIME,动漫音乐,游戏,游戏解说,二次元,游戏视频,ACG,galgame,动画,番组,新番,初音,洛天依,vocaloid,日本动漫,国产动漫,手机游戏,网络游戏,电子竞技,哲学,kurper,黑岩射手"},{"name":"application-name","content":"喵御宅"},{"name":"screen-orientation","content":"portrait"},{"name":"x5-orientation","content":"portrait"},{"name":"baidu-site-verification","content":"codeva-lLMsRpPX4e"},{"name":"naive-ui-style"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"preconnect","href":"https://resource.mfuns.net","crossorigin":""},{"rel":"preload","href":"https://resource.mfuns.net/css/rimuru/rimuru.min.css","as":"style","onload":"this.onload=null;this.rel='stylesheet'"},{"rel":"stylesheet","href":"https://resource.mfuns.net/css/bak/icon/nya-icons.css","media":"print","onload":"this.onload=null;this.media='all'"},{"rel":"stylesheet","href":"https://resource.mfuns.net/css/bak/lucide/lucide.css","media":"print","onload":"this.onload=null;this.media='all'"},{"rel":"stylesheet","href":"https://resource.mfuns.net/css/bak/tagify.css","media":"print","onload":"this.onload=null;this.media='all'"},{"rel":"stylesheet","href":"https://resource.mfuns.net/css/bak/editor.css","media":"print","onload":"this.onload=null;this.media='all'"},{"rel":"stylesheet","href":"https://resource.mfuns.net/css/bootstrap-icons-1.13.1/bootstrap-icons.min.css","media":"print","onload":"this.onload=null;this.media='all'"}],"style":[],"script":[{"async":true,"defer":true,"src":"https://www.googletagmanager.com/gtag/js?id=G-1ZEVD4C935"},{"async":true,"defer":true,"innerHTML":"window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n\n          gtag('config', 'G-1ZEVD4C935');"},{"async":true,"defer":true,"innerHTML":"var _czc = _czc || [];\n        (function () {\n            var um = document.createElement(\"script\");\n            um.src = \"https://s9.cnzz.com/z.js?id=1281271400&async=1\";\n            var s = document.getElementsByTagName(\"script\")[0];\n            s.parentNode.insertBefore(um, s);\n        })();"},{"src":"https://zz.bdstatic.com/linksubmit/push.js","async":true,"defer":true},{"type":"application/ld+json","innerHTML":"{\"@context\":\"https://schema.org\",\"@type\":\"WebSite\",\"name\":\"喵御宅\",\"alternateName\":\"Mfuns\",\"url\":\"https://www.mfuns.net/\"}"}],"noscript":[],"title":"喵御宅，兴趣至上的ACGN社区(。゜ω゜)ノ\"!","htmlAttrs":{"lang":"zh"},"viewport":"width=device-width, initial-scale=1, maximum-scale=5, viewport-fit=cover"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootTag = "div"

export const appRootAttrs = {"id":"m-app"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#m-app'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false